import React, { useEffect, useState } from 'react';
import { AiFillCalculator } from 'react-icons/ai';

function App() {
  const [length, setlength] = useState(0);
  const [measurementUnit, setMeasurementUnit] = useState('cm');
  const [height, setheight] = useState(0);
  const [weight, setweight] = useState(0);
  const [depth, setdepth] = useState(0);
  const [width, setwidth] = useState(0);
  const [volume, setvolume] = useState(0);
  const [totalsubstrate, settotalsubstrate] = useState(0);
  const [currentRatio, setCurrentRatio] = useState('4:1');

  const [substrate, setSubstrate] = useState(0);
  const [spawn, setSpawn] = useState(0);
  const [bags, setBags] = useState('');

  useEffect(() => {
    setvolume(length * height * width);

    settotalsubstrate(width * length * depth);
  }, [length, height, width, depth]);

  useEffect(() => {
    if (currentRatio === '1:1') {
      let totalvalue = totalsubstrate / 2;
      setSpawn(Math.round(totalvalue  / 100)/10);
      setSubstrate(Math.round(totalvalue  / 100)/10);
      setweight(
        `${Math.round(totalvalue / 2)} g/${Math.round(totalvalue / 2000)}Kg`
      );
    } else if (currentRatio === '2:1') {
      let totalvalue = totalsubstrate / 3;

      setSpawn(Math.round(totalvalue  / 100)/10);
      setSubstrate(Math.round((totalvalue * 2) / 100)/10);
      setweight(
        `${Math.round(totalvalue / 2)} g/${Math.round(totalvalue / 2000)}Kg`
      );
    } else if (currentRatio === '3:1') {
      let totalvalue = totalsubstrate / 4;

      setSpawn(Math.round(totalvalue  / 100)/10);
      setSubstrate(Math.round((totalvalue * 3) / 100)/10);
      setweight(
        `${Math.round(totalvalue / 2)} g/${Math.round(totalvalue / 2000)}Kg`
      );
    } else if (currentRatio === '4:1') {
      let totalvalue = totalsubstrate / 5;

      setSpawn(Math.round(totalvalue / 100)/10);
      setSubstrate(Math.round((totalvalue * 4)  / 100)/10);
      setweight(
        `${Math.round(totalvalue / 2)} g/${Math.round(totalvalue / 2000)}Kg`
      );
    } else if (currentRatio === '5:1') {
      let totalvalue = totalsubstrate / 6;

      setSpawn(Math.round(totalvalue  / 100)/10);
      setSubstrate(Math.round((totalvalue * 5)  / 100)/10);
      setweight(
        `${Math.round(totalvalue / 2)} g/${Math.round(totalvalue / 2000)}Kg`
      );
    }

    totalsubstrate > 5000
      ? setBags(Math.round(totalsubstrate / 5000))
      : setBags(1);
  }, [currentRatio, totalsubstrate]);

  console.log('Substrate:', substrate);
  console.log('Spawn:', spawn);

  return (
    <div className="flex items-center justify-center w-full p-8">
      <div className="container flex flex-col justify-center">
     
        <div className="flex justify-center items-center">
          <div className="flex justify-center items-center flex-col mt-1">
            <label
              htmlFor="measurementUnit"
              className="inline-block text-md font-medium text-gray-700 p-1"
            >
              Measurement Unit
            </label>
            <select
              id="measurementUnit"
              name="measurementUnit"
              className="border-transparent cursor-pointer bg-transparent rounded-lg h-10 w-20 border border-gray-400 text-gray-500 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              onChange={(e) => {
                setMeasurementUnit(e.target.value);
              }}
            >
              <option className="cursor-pointer">cm</option>
              <option>inch</option>
            </select>
          </div>

          <div className="flex justify-center items-center">
            <div className="flex flex-col items-center justify-center mr-4">
              <label
                htmlFor="length"
                className="inline-block text-md font-medium text-gray-700 p-1"
              >
                Length
              </label>
              <div className="relative mt-1 rounded-md shadow-sm">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <span className="text-gray-500 sm:text-sm">L</span>
                </div>
                <input
                  type="number"
                  name="length"
                  id="length"
                  className="block rounded-lg h-10 w-20 border border-gray-400 pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="0"
                  onChange={(e) => {
                    if (measurementUnit === 'cm') {
                      setlength(e.target.value);
                    } else {
                      setlength(e.target.value * 2.54);
                    }
                  }}
                />
              </div>
            </div>
            <div className="flex flex-col items-center justify-center  mr-4">
              <label
                htmlFor="height"
                className="inline-block text-md font-medium text-gray-700 p-1"
              >
                Height
              </label>
              <div className="relative mt-1 rounded-md shadow-sm">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <span className="text-gray-500 sm:text-sm">H</span>
                </div>
                <input
                  type="number"
                  name="height"
                  id="height"
                  className="block rounded-lg h-10 w-20 border border-gray-400 pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  placeholder="0"
                  onChange={(e) => {
                    if (measurementUnit === 'cm') {
                      setheight(e.target.value);
                    } else {
                      setheight(e.target.value * 2.54);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center flex-col">
            <label
              htmlFor="width"
              className="inline-block text-md font-medium text-gray-700 p-1"
            >
              Width
            </label>
            <div className="relative mt-1 rounded-md shadow-sm">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span className="text-gray-500 sm:text-sm">W</span>
              </div>
              <input
                type="number"
                name="width"
                id="width"
                className="block rounded-lg h-10 w-20 border border-gray-400 pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="0"
                onChange={(e) => {
                  if (measurementUnit === 'cm') {
                    setwidth(e.target.value);
                  } else {
                    setwidth(e.target.value * 2.54);
                  }
                }}
              />
            </div>
          </div>
          <div className="flex items-center justify-center flex-col">
            <label
              htmlFor="depth"
              className="inline-block text-md font-medium text-gray-700 p-1"
            >
              Substrate Depth
            </label>
            <div className="relative mt-1 rounded-md shadow-sm">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <span className="text-gray-500 sm:text-sm">D</span>
              </div>
              <input
                type="number"
                name="depth"
                id="depth"
                className="block rounded-lg h-10 w-20 border border-gray-400 pl-7 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="0"
                onChange={(e) => {
                  if (measurementUnit === 'cm') {
                    setdepth(e.target.value);
                  } else {
                    setdepth(e.target.value * 2.54);
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="w-full flex items-center justify-center text-center p-6 text-green-600 font-bold">
          <span>*We recommend a substrate depth of 8cm / 3.15 inch</span>
        </div>
        <div className="flex justify-center items-center flex-col">
          <div className="flex space-x-2 items-center">
            <label
              htmlFor="totalvolume"
              className="inline-block text-lg font-bold text-black p-1"
            >
              Total Volume of Container
            </label>
            {/* <textarea
            id="totalvolume"
            className="text-gray-500 p-2 border border-gray-400 rounded"
            defaultValue={Math.round(volume)}
            disabled
          /> */}
            <p>{Math.round(Math.round(volume) / 1000)} Litres</p>
          </div>
          <div className="flex space-x-2 items-center">
            <label
              htmlFor="totalvolume"
              className="inline-block text-lg font-bold text-black p-1"
            >
              Total Spawn and Substrate Needed:
            </label>
            {/* <textarea
              id="totalvolume"
              className="text-gray-500 p-2 border border-gray-400 rounded"
              defaultValue={Math.round(totalsubstrate)}
              disabled
            /> */}
            <p>{Math.round(totalsubstrate / 1000)} Litres</p>
          </div>
        </div>
        <div className="flex justify-center items-center flex-col">
          <label
            htmlFor="spawntosubstrateratio"
            className="inline-block text-lg font-medium text-gray-700 p-1"
          >
            Select your substrate to spawn ratio:
          </label>
          <div className="w-full flex items-center justify-center text-center p-1 text-green-600 font-bold">
            <span>*We recommend a ratio of 4:1</span>
          </div>
          <select
            id="spawntosubstrateratio"
            name="spawntosubstrateratio"
            className="border-transparent cursor-pointer bg-transparent rounded-lg h-10 w-20 border font-bold text-black border-gray-400  focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            defaultValue={currentRatio}
            // ref={spawnToSubstrateRatioRef}
            // onChange={(e) => {}}
            onChange={(e) => setCurrentRatio(e.target.value)}
          >
            <option value={'1:1'}>1:1</option>
            <option value={'2:1'}>2:1</option>
            <option value={'3:1'}>3:1</option>
            <option value={'4:1'}>4:1</option>
            <option value={'5:1'}>5:1</option>
          </select>
        </div>

        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center space-x-2 flex-col">
            <label
              htmlFor="spawn"
              className="inline-block text-lg font-bold text-black p-1"
            >
              Total volume of spawn needed:
            </label>
            {/* <textarea
            id="spawn"
            className="text-gray-500 p-2 border border-gray-400 rounded"
            defaultValue={spawn}
            disabled
          /> */}
            <p className="text-xl text-green-600 font-bold">{spawn} Litres</p>
          </div>
          <div className="flex items-center space-x-2 flex-col">
            <label
              htmlFor="substrate"
              className="inline-block text-lg font-bold text-black p-1"
            >
              Total volume of substrate needed:
            </label>
            {/* <textarea
            id="substrate"
            className="text-gray-500 p-2 border border-gray-400 rounded"
            defaultValue={substrate}
            disabled
          /> */}
            <p className="text-xl text-green-600 font-bold">
              {' '}
              {substrate} Litres
            </p>
          </div>
          {/* <label
            htmlFor="grainweight"
            className="inline-block text-lg font-medium text-gray-700 p-1"
          >
            Grain weight
          </label>
          <textarea
            id="bags"
            className="text-gray-500 p-2 border border-gray-400 rounded"
            defaultValue={weight}
            disabled
          />
          <br /> */}
          {/* <label
            htmlFor="bags"
            className="inline-block text-lg font-medium text-gray-700 p-1"
          >
            Bags Needed
          </label>
          <textarea
            id="bags"
            className="text-gray-500 p-2 border border-gray-400 rounded"
            defaultValue={bags}
            disabled
          /> */}
        </div>
      </div>
    </div>
  );
}

export default App;
